module.exports = __webpack_public_path__ + "static/media/intero_rose.fe730acc.svg";